import React, { useState, useEffect } from "react";
import {
  Card,
  Container,
  InputGroup,
  FormControl,
  Button,
  Spinner,
} from "react-bootstrap";
import Logo from "../Components/Logo";

import useOTPHandler from "../Services/useOTPHandler";
import { useHistory } from "react-router-dom";
import { getPersistingQueryStrings } from "../helpers";

let Login = ({ match }: any) => {
  let history = useHistory();
  let { mobileNumber, setMobileNumber, sendOTP } = useOTPHandler.useContainer();
  const [isValid, setisValid] = useState(false);
  const [isError, setisError] = useState(false);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [matchedUrl] = useState(match?.params?.linkid);

  let handleOnClick = async () => {
    try {
      setLoading(true);
      await sendOTP();
      history.push({
        pathname: "/otp",
        search: getPersistingQueryStrings(),
        state: { matchedUrl }
      });
    } catch ({ response }) {
      const { data }: any = response;
      if (data.data.code === 'ACCOUNT_BLOCKED') {
        setErr(data.data.message);
      }
      setisError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mobileNumber) {
      setisValid(true);
    }
  }, [])

  return (
    <Card className="main-card d-flex align-items-center justify-content-center p-5 h-100 w-100">
      <Logo />
      <span className="otp-label my-2">Connect your JoyRide Account</span>
      <InputGroup className="mt-4 mb-3 input-group">
        <InputGroup.Prepend>
          <InputGroup.Text className="input-text">+63</InputGroup.Text>
        </InputGroup.Prepend>
        <FormControl
          className="input-number"
          size="lg"
          placeholder="Mobile Number"
          aria-label="Phone"
          type="number"
          value={mobileNumber}
          onChange={(e: any) => {
            const re = /^[0-9\b]+$/;
            if (e.target.value === "" || re.test(e.target.value)) {
              if (e.target.value.length <= 10) {
                setMobileNumber(e.target.value);

                if (e.target.value.length === 10) {
                  setisValid(true);
                } else {
                  setisValid(false);
                }
              }
            }
          }}
        />
      </InputGroup>
      {!isError ? null : (
        <span
          style={{ marginTop: 0 }}
          className="otp-description text-danger"
        >
          {err ? err : 'Something, is wrong please try again.'}
        </span>
      )}
      <Button
        disabled={loading || !isValid}
        className="jr-btn"
        onClick={handleOnClick}
      >
        {loading ? <Spinner animation="border" size="sm" /> : "Log In"}
      </Button>
    </Card>
  );
};

export default Login;
